import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  image: string;
}

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.categorySlug === slug);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <div className="text-center">
          <title>分类不存在 - 51黑料吃瓜网</title>
          <h1 className="text-2xl font-heading font-bold text-foreground-950 mb-2">分类不存在</h1>
          <Link to="/" className="text-primary-500 hover:text-primary-600 text-sm whitespace-nowrap">返回首页</Link>
        </div>
      </div>
    );
  }

  const pageTitle = `${category.name} - 51黑料吃瓜网 | 最新爆料在线观看`;
  const pageDescription = `${category.description}，51黑料吃瓜网为您提供${category.name}最新最全的独家猛料和吃瓜视频，7×24小时不打烊更新。`;

  return (
    <>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={`${category.name},51黑料,吃瓜网,黑料爆料,51黑料在线观看,每日黑料大赛`} />
      <link rel="canonical" href={`https://51heiliao.com/category/${slug}`} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://51heiliao.com/category/${slug}`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />

      <SchemaOrg
        type="WebPage"
        data={{
          name: pageTitle,
          url: `https://51heiliao.com/category/${slug}`,
          description: pageDescription,
          isPartOf: {
            '@type': 'WebSite',
            name: '51黑料吃瓜网',
            url: 'https://51heiliao.com/',
          },
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: '首页',
              item: 'https://51heiliao.com/',
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: category.name,
            },
          ],
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <section className="relative w-full h-[420px] md:h-[500px] flex items-center overflow-hidden">
          <img
            src={category.image}
            alt={category.name}
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
          <div className="relative z-10 w-full px-4 md:px-6">
            <div className="max-w-[1400px] mx-auto">
              <div className="max-w-2xl">
                <span className="inline-block px-4 py-1.5 rounded-full border border-white/40 text-white/90 text-xs md:text-sm font-medium mb-4 whitespace-nowrap">
                  <i className={`${category.icon} mr-1.5`}></i>
                  {category.name}
                </span>
                <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-3">
                  {category.name}
                </h1>
                <p className="text-white/70 text-sm md:text-base max-w-lg leading-relaxed">
                  {category.description}
                </p>
              </div>
            </div>
          </div>
        </section>

        <main>
          <Breadcrumb items={[{ label: category.name }]} />

          <section className="w-full py-10 md:py-14 bg-background-50">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
                  频道索引
                </h2>
                <p className="text-foreground-500 text-sm">
                  浏览{category.name}下的所有子频道
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {categories.filter(c => c.slug !== slug).slice(0, 4).map((subCat) => (
                  <Link
                    key={subCat.slug}
                    to={`/category/${subCat.slug}`}
                    className="group bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:bg-primary-500 hover:border-primary-500 transition-all duration-300 cursor-pointer"
                  >
                    <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-3 group-hover:bg-white/20 transition-colors">
                      <i className={`${subCat.icon} text-lg text-secondary-600 group-hover:text-white transition-colors`}></i>
                    </div>
                    <h3 className="text-sm font-bold text-foreground-900 group-hover:text-white mb-1 transition-colors whitespace-nowrap">
                      {subCat.name}
                    </h3>
                    <p className="text-xs text-foreground-500 group-hover:text-white/70 leading-relaxed transition-colors">
                      {subCat.description}
                    </p>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full py-10 md:py-14 bg-background-100">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
                {category.name}最新爆料
              </h2>
              {categoryArticles.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
                  {categoryArticles.map((article) => (
                    <Link
                      key={article.slug}
                      to={`/article/${article.slug}`}
                      className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                    >
                      <div className="relative w-full aspect-[4/3] overflow-hidden">
                        <img
                          src={article.image}
                          alt={article.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                        {article.isExclusive && (
                          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-foreground-950/80 text-white text-xs font-medium whitespace-nowrap">
                            独家
                          </span>
                        )}
                        {article.isVideo && (
                          <span className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/50 flex items-center justify-center">
                            <i className="ri-play-fill text-white text-sm"></i>
                          </span>
                        )}
                      </div>
                      <div className="p-4">
                        <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2 leading-snug">
                          {article.title}
                        </h3>
                        <div className="flex items-center justify-between text-xs text-foreground-400">
                          <span>{article.publishDate}</span>
                          <span className="flex items-center gap-1">
                            <i className="ri-eye-line"></i>
                            {article.readCount}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <p className="text-foreground-400 text-sm">该分类暂无文章，敬请期待</p>
                </div>
              )}
            </div>
          </section>

          <section className="w-full py-12 md:py-16 bg-background-50">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6">
              <div className="text-center mb-8">
                <span className="text-xs text-foreground-400 font-heading italic">数据背书</span>
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mt-2 mb-1">
                  {category.name}全网热度
                  <span className="font-heading italic font-bold text-primary-500">持续飙升</span>
                </h2>
                <p className="text-foreground-500 text-sm">数据更新时间：2026年7月</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto">
                <div className="bg-primary-100/80 rounded-xl p-6 md:p-8 relative overflow-hidden">
                  <span className="absolute top-5 right-5 w-10 h-10 rounded-full bg-white/30 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-primary-600"></i>
                  </span>
                  <div className="text-4xl md:text-5xl font-heading font-bold text-primary-700 mb-2">50M+</div>
                  <p className="text-sm text-foreground-700 font-medium mb-1">累计阅读量</p>
                  <p className="text-xs text-foreground-500 leading-relaxed">{category.name}相关内容在全平台的累计阅读量已突破5000万次</p>
                  <p className="text-xs text-foreground-400 italic mt-3">—— 数据说话，热度为王</p>
                </div>
                <div className="bg-accent-100/80 rounded-xl p-6 md:p-8 relative overflow-hidden">
                  <span className="absolute top-5 right-5 w-10 h-10 rounded-full bg-white/30 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-accent-600"></i>
                  </span>
                  <div className="text-4xl md:text-5xl font-heading font-bold text-accent-700 mb-2">98%</div>
                  <p className="text-sm text-foreground-700 font-medium mb-1">用户满意度</p>
                  <p className="text-xs text-foreground-500 leading-relaxed">用户调研显示，98%的吃瓜群众对{category.name}的内容质量和更新速度表示满意</p>
                  <p className="text-xs text-foreground-400 italic mt-3">—— 口碑铸就信赖</p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}